<ng-container *transloco="let t; read: 'deleteConfirmDialog'">
  <kendo-dialog
      title="{{ title || t('confirmDeletion') }}"
      *ngIf="opened"
      (close)="close('cancel')"
      [minWidth]="250"
      [width]="450">
      <p style="margin: 30px; text-align: center;">
          {{ message || t('deletionMessage') }}
      </p>
      <kendo-dialog-actions>
          <button kendoButton type="button" (click)="close('cancel')">{{ t('cancelButton') }}</button>
          <button kendoButton type="button" (click)="close('delete')" themeColor="primary">{{ t('deleteButton') }}
          </button>
      </kendo-dialog-actions>
  </kendo-dialog>
</ng-container>
